import Logo from 'assett/icons/logo.svg';
import SelectBanner from 'components/commons/form/SelectBanner';
import SelectLanguage from 'components/commons/form/SelectLanguage';
import SkipToMainContentLink from 'components/commons/SkipToMainContentLink';
import UserProvider from 'components/Dahsboard/User/UserProvider.component';
import useDevice from 'hooks/DesktopDevice.hook';
import useDialogConfirm from 'hooks/DialogConfirm.hook';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { RootState } from 'store/store';
import { Box } from 'styles';
import Container from 'styles/container/Container';
import Stack from 'styles/stack/Stack';
import Typography from 'styles/typography/Typograpy';
import { VERSION } from 'types/dialogtypes';
import { useTranslation } from 'utils/translations';
import { FooterDesktop } from './FooterDesktop/FooterDesktop';
import { NotificationsButton } from './NotificationsButton.component';

const DashboardLayout = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { profile } = useSelector((store: RootState) => store.user);
	const { isDesktop } = useDevice();
	const confirmDialog = useDialogConfirm();

	return (
		<Container>
			<SkipToMainContentLink />
			<Stack
				justifyContent="space-between"
				height={!isDesktop ? `${window.innerHeight}px` : '100vh'}
			>
				<Box>
					<Stack
						sx={{ mt: 6.25 }}
						direction={'row'}
						justifyContent={'space-between'}
					>
						<Stack>
							<Typography variant="title1" role="heading" aria-level={1}>
								{tClientLabels('dashboard.pageTitle')}
							</Typography>
							<Typography
								variant={!!isDesktop ? 'title2' : 'title4'}
								sx={{ color: 'primary3.main' }}
							>
								{profile?.name as string}
							</Typography>
						</Stack>
						<Stack alignItems={'flex-end'} sx={{ mt: { sm: 0, lg: 2.5 } }}>
							<Box width="48px" height="49px">
								<img
									onClick={() => {
										confirmDialog.open(VERSION);
									}}
									src={Logo}
									alt={`${tClientLabels('commons.logo.alt')}`}
									loading="lazy"
									style={{
										width: '200%',
										height: '200%',
										transformOrigin: '0 0',
										transform: 'scale(0.5)',
									}}
								/>
							</Box>
						</Stack>
					</Stack>
					<Stack direction={'row'} justifyContent="space-between">
						<Stack direction={'row'} gap={3} width={{ sm: '68%', lg: '100%' }}>
							<Box width={{ sm: '100%', lg: '805px' }} position="relative">
								<UserProvider />
							</Box>
							{isDesktop && (
								<Box width={'420px'}>
									<SelectBanner />
								</Box>
							)}
						</Stack>
						<Box>
							<SelectLanguage />
						</Box>
					</Stack>
					<Stack direction={'row'} justifyContent="space-between">
						<Box mt={{ sm: 6.75, lg: 10 }} width="100%">
							<NotificationsButton />
						</Box>
						{!isDesktop && (
							<Box width={'100%'} display={'flex'} justifyContent={'right'}>
								<Box width={'327px'}>
									<SelectBanner />
								</Box>
							</Box>
						)}
					</Stack>
				</Box>
				<Stack mb={!!isDesktop ? 6.5 : 2.5}>
					<Outlet />
				</Stack>
				<FooterDesktop />
			</Stack>
		</Container>
	);
};

export default DashboardLayout;
